import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  BaseServiceFacade,
  GenericApiCall,
} from '../../../../common/store/types';
import { AppState } from '../../types';
import { commissionActions } from './commission.actions';
import { commissionSelectors } from './commission.selector';
import {
  CommissionModel,
  CommissionPreviewModel,
  CommissionReportModel,
  CommissionReportSalesPersonCommissionsDashboardModel,
  CommissionReportSalesPersonProductionDashboardModel,
  SalesPersonCommissionListModel,
  SalesPersonCommissionModel,
} from './types';
import { Filter } from '../../search/types';

@Injectable()
export class CommissionService extends BaseServiceFacade {
  constructor(store: Store<AppState>) {
    super(store);
  }
  getById: GenericApiCall<CommissionModel, string> = this.genericApiCall(
    commissionActions.getById,
    commissionSelectors.getById,
    true,
  );
  getCommissionsPreview: GenericApiCall<CommissionPreviewModel[], string> =
    this.genericApiCall(
      commissionActions.getCommissionsPreview,
      commissionSelectors.getCommissionsPreview,
      true,
    );
  add: GenericApiCall<
    CommissionPreviewModel[],
    {
      commissionPreviewModels: CommissionPreviewModel[];
      isTotalRowCountSelected: boolean;
    }
  > = this.genericApiCall(commissionActions.add, commissionSelectors.add, true);

  addSalesPersonCommissionPayment: GenericApiCall<
    boolean,
    SalesPersonCommissionListModel
  > = this.genericApiCall(
    commissionActions.addSalesPersonCommissionPayment,
    commissionSelectors.addSalesPersonCommissionPayment,
    true,
  );

  deleteSalesPersonCommissions: GenericApiCall<
    boolean,
    SalesPersonCommissionListModel
  > = this.genericApiCall(
    commissionActions.deleteSalesPersonCommissions,
    commissionSelectors.deleteSalesPersonCommissions,
    true,
  );

  deleteSalesPersonCommissionPayment: GenericApiCall<boolean, number[]> =
    this.genericApiCall(
      commissionActions.deleteSalesPersonCommissionPayment,
      commissionSelectors.deleteSalesPersonCommissionPayment,
      true,
    );

  getCompanyCommissions: GenericApiCall<CommissionReportModel[], string> =
    this.genericApiCall(
      commissionActions.getCompanyCommissions,
      commissionSelectors.getCompanyCommissions,
      true,
    );

  getExcludedTaxAnnualFees: GenericApiCall<CommissionReportModel[], string> =
    this.genericApiCall(
      commissionActions.getExcludedTaxAnnualFees,
      commissionSelectors.getExcludedTaxAnnualFees,
      true,
    );

  getApplicationFeesReport: GenericApiCall<CommissionReportModel[], string> =
    this.genericApiCall(
      commissionActions.getApplicationFeesReport,
      commissionSelectors.getApplicationFeesReport,
      true,
    );

  getSalesPersonProductionDashboardData: GenericApiCall<
    CommissionReportSalesPersonProductionDashboardModel,
    Filter[]
  > = this.genericApiCall(
    commissionActions.getSalesPersonProductionDashboardData,
    commissionSelectors.getSalesPersonProductionDashboardData,
    true,
  );

  getSalesPersonCommissionsDashboardData: GenericApiCall<
    CommissionReportSalesPersonCommissionsDashboardModel,
    Filter[]
  > = this.genericApiCall(
    commissionActions.getSalesPersonCommissionsDashboardData,
    commissionSelectors.getSalesPersonCommissionsDashboardData,
    true,
  );
}
